
//系统通知分装处理
import url from './urlHelper.js';
import user from './user.js';
var singlR = require('@aspnet/signalr');
import { Notification } from 'element-ui';
import Router from 'vue-router'
import Vue from 'vue'

var con = new singlR.HubConnectionBuilder()
    .withUrl(url.getDomain() + '/ws_notice')
    .build();//链接定义
var count = 0;
export default {
    isConnect() {
        return con.state == 1;
    },
    init() {
        var _this = this;
        if (this.isConnect()) {

        } else {
            _this.watch();
            _this.start();
        }
    },
    async start() {
        var _this = this;
        try {
            await con.start();
        }
        catch (e) {
            setTimeout(() => {
                if (count <= 2) {
                    _this.start();
                }
                count++;
            }, 5000);
        }
        //事件监听
        con.onclose(async () => {

            if(user.isLogin()){
                setTimeout(() => {
                    _this.start();
                }, 1000);
            }
        });

    },
    //服务端通知监听
    watch() {
        var _this = this;
        con.on('send', data => {

            _this.play();
            _this.show(data);
        });
    },
    //声音播放
    play() {
        //播放声音
        var audio = document.getElementById('audioOne');
        audio.currentTime = 0;
        audio.play();
    },
    //通知显示
    show(item) {
        var summary = item.summary;
        if (item.url) {
            summary += '<br /> <a href="javascript:void(0);" onclick="winOpen(\'' + item.url + '\',this);" class="router-link-active">点击查看</a>';
            Notification.success({
                title: 'Info',
                title: item.title,
                dangerouslyUseHTMLString: true,
                message: summary,
                showClose: true,
                duration: 0,
                position: 'right-center'
            });
        } else {
            Notification.success({
                title: 'Info',
                title: item.title,
                dangerouslyUseHTMLString: true,
                message: summary,
                showClose: true,
                position: 'right-center'
            });
        }
    }
}

